import { Action } from '@ngrx/store';

export const USER_IDENTITY_UPDATED = '[Security] User Identity Updated';

export class UserIdentityUpdatedAction implements Action {
  readonly type = USER_IDENTITY_UPDATED;

  constructor(public payload: { claims: any, authToken: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/UserIdentityUpdatedAction.ts